import {
  SR_API_ACTION_UTILITY_LOGONAS,
  SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID,
} from 'api/utilityActionTypes';

import getUtilityActivationByUserIdAction from 'client/actions/UtilityActivation/getByUserId';

export default async function logonas(
  { state, utilityApiClient },
  { phone, utilityPartnerId, redirectUrl },
) {
  const result = await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_LOGONAS,
    state: state,
    payload: {
      phone,
      utilityPartnerId,
    },
  });

  if (redirectUrl) {
    global.location.replace(redirectUrl);
    return;
  }

  const user = result?.user || null;

  if (user.utilityPartnerId) {
    const utilityPartner = await utilityApiClient.postWithState({
      action: SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID,
      state: state,
      payload: {
        id: user.utilityPartnerId,
      },
    });
    if (utilityPartner) {
      global.location.replace(`/utility-profit/${utilityPartner.slug}`);
      return;
    }
  }

  const utilityActivation = await getUtilityActivationByUserIdAction(
    { state, utilityApiClient },
    { utilityUserId: user.id },
  );
  if (utilityActivation) {
    global.location.replace(
      `/utility-setup/${utilityActivation.partner?.slug}/${utilityActivation.shortId}`,
    );
  } else {
    global.location.reload();
  }
}
